import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";


//Tabla, Navbar y Sidebar
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import CustomTableBackendFilters from "../../../components/CustomTableBackendFilters";

//redux
import {
  editLevelEmployee,
  saveLevelEmployee,
  getLevelEmployee,
  deleteLevelEmployee
} from "../../../redux/evaluacion_desempenio/LevelEmployee/actions"
import { Typeahead } from "react-bootstrap-typeahead";
import { getLevel } from "../../../redux/evaluacion_desempenio/Level/actions";
import SearchEmployee from "../../../components/evaluacion_desempenio/LevelEmployee/SearchEmployee";

//Esquema de validación
const schema = Yup.object().shape({
  nivel: Yup.string().ensure().required("**Campo requerido")
});

const LevelEmployee = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //Variables para filtrado y paginación
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});

  //Variables para editar
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [selectedEmployee, setSelectedEmployee] = useState("")

  //Variables para el formulario
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showSearchEmployee, setShowSearchEmployee] = useState("")


  //Redux
  const dispatch = useDispatch();
  const levelEmployeeStore = useSelector(
    (store) => store.levelEmployee
  );


  const {
    loading,
    levelEmployees,
    levelEmployeesLength,
    levelEmployeeError,
    saveLoading,
    formError,
  } = levelEmployeeStore;

  const {
    loading: loadingLevels,
    levels
  } = useSelector((store) => store.level);

  const levelsOptions = levels?.map((level) => ({
    id: level.id,
    label: level.nombre
  })) || [];

  useEffect(() => {
    dispatch(getLevel())
  }, []);


  useEffect(() => {
    dispatch(getLevelEmployee({
      limit,
      offset,
      estado: "True",
      ...filters
    }));
  }, [limit, offset, filters]);

  const pages = Math.ceil(
    levelEmployees ? levelEmployeesLength / limit : 0
  );

  const columns = [
    {
      Header: "Código Empleado",
      accessor: "empleado_data.codigo",
      filterType: "text",
      filterName: "empleado__codigo__icontains"
    },
    {
      Header: "Nombre Empleado",
      accessor: "empleado_data.nombre",
      filterType: "text",
      filterName: "empleado__nombre__icontains"
    },
    {
      Header: "Nivel",
      accessor: "nivel_data.nombre",
      filterType: "text",
      filterName: "nivel__nombre__icontains"
    },

    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      filterType: "date",
      filterName: "fecha_creacion__date__icontains",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  //Funciones
  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setSelectedEmployee({ id: item.empleado_data.id, nombre: item.empleado_data.nombre, codigo: item.empleado_data.codigo })
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteLevelEmployee(id, data));
    }
  };


  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };



  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setOffset(0);
  };

  const _getLevels = (offs = offset, lim = limit) => {
    setOffset(offs);
    setLimit(lim);
  };

  const onCloseModal = () => {
    setShowFormModal(false)
    setSelectedEmployee("")
  }


  const onSubmit = async (req) => {

    if (!selectedEmployee) {
      toastr.error("Debe seleccionar un empleado.")
      return
    }

    let data = {
      empleado: selectedEmployee.id,
      nivel: req.nivel
    }
    if (!edit) {
      await dispatch(saveLevelEmployee(data, setShowFormModal));
    } else {
      await dispatch(editLevelEmployee(data, editItem.id, index, setShowFormModal));
    }
    setSelectedEmployee("")
    await dispatch(getLevelEmployee({
      limit,
      offset,
      estado: "True",
      ...filters
    }));
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              NIVEL EMPLEADO
            </h5>
            <Form>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!levelEmployeeError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {levelEmployeeError}
            </Alert>
          )}

          <Card className="border-0">
            <Card.Body className="px-1 px-sm-2">
              <CustomTableBackendFilters
                columns={columns}
                data={levelEmployees || []}
                isLoadingData={loading}
                onFiltersChange={handleFiltersChange}
                filters={filters}
              />
            </Card.Body>
          </Card>
          <CustomPagint
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dataLenght={levelEmployeesLength}
            pages={pages}
            pagFunc={_getLevels}
          />

        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={onCloseModal}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nivel: edit ? editItem.nivel : ""
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              setFieldValue,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Nivel Empleado"
                      : "Crear Nivel Empleado"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {formError &&
                    typeof formError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {formError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Empleado
                    </Form.Label>
                    <Row>
                      <Col sm={10}>
                        <Form.Control
                          name="empleado"
                          className="rounded-pill"
                          required
                          type="text"
                          disabled
                          value={selectedEmployee ? `${selectedEmployee.codigo} / ${selectedEmployee.nombre}` : ""}
                          placeholder="Empleado"
                        ></Form.Control>
                      </Col>
                      <Col sm="1">
                        <Button className="rounded-pill" onClick={() => setShowSearchEmployee(true)}>
                          <i className="material-icons">search</i>
                        </Button>
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group as={Col} sm={12} md={12} lg={12} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Nivel
                    </Form.Label>
                    <div className="d-flex align-items-center">
                      <Typeahead
                        className="w-100"
                        id="nivel"
                        name="nivel"
                        disabled={loadingLevels}
                        placeholder="Seleccione un nivel"
                        options={levelsOptions}
                        isValid={touched.nivel && !errors.nivel}
                        isInvalid={touched.nivel && errors.nivel}
                        onBlur={handleBlur("nivel")}
                        onChange={(selected) => {
                          console.log(selected)
                          setFieldValue("nivel", selected.length > 0 ? selected[0].id : "");
                        }}
                        defaultInputValue={edit ? editItem?.nivel_data?.nombre : ""}
                      >
                      </Typeahead>
                      {loadingLevels && (
                        <Spinner
                          className="ml-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />)}
                    </div>

                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={onCloseModal}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
        <SearchEmployee
          empleado={selectedEmployee}
          setEmpleado={setSelectedEmployee}
          setShowFormModal={setShowSearchEmployee}
          showFormModal={showSearchEmployee}
        />
      </div>
    </>
  );
};

export default LevelEmployee;
